import { TourCategory } from 'generated/mos/org/getty/audio'
import { TranslatableStringValue } from 'generated/mos/translatable'

import { Schema } from 'helpers/schema'

import {
  createTranslatableStringValue,
  getTranslatableValue,
  setTranslatableValue,
} from 'helpers/translatables'

const isNonEmpty = (value: any) => {
  if (typeof value === 'string' && (!value || !value.trim().length)) {
    return false
  }

  return value
}

export const categorySchema: Schema<TourCategory.Entity> = {
  name: {
    read: (value, language) => getTranslatableValue(value, language) as any,
    write: (value, existingValue, language) => isNonEmpty(value) ? setTranslatableValue(
      createTranslatableStringValue(value as any, language),
        existingValue ?
          existingValue as TranslatableStringValue.Entity :
          TranslatableStringValue.defaults,
      ) as any as TranslatableStringValue.Entity : undefined,
  },
}
